import { useContext } from 'react';
import { GenerateActivityReportJobContext } from './context';

export default function useGenerateActivityReportJobContext() {
  return useContext(GenerateActivityReportJobContext);
}
